module.exports = __webpack_public_path__ + "img/home2.3be6647d.png";